// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"modalOverlay-2foYz","modalBase":"modalBase-3QllG","banner":"banner-XsbkX","fadeOut":"fadeOut-2V9AV","icon":"icon-2jJNO","heading":"heading-JfQrg"};